<template>
	<div class="main">
		<navigation-bar v-bind:userData="userData"></navigation-bar>
		<left-bar v-bind:userData="userData"></left-bar>
		<right-bar v-bind:userData="userData"></right-bar>
		<dashboard-bar></dashboard-bar>
	</div>
</template>

<script>
	/* eslint-disable */
	global.pfAirViewer = new Cesium.AirViewer('mapServer');
	//Cesium.TrustedServers.add("172.18.0.169", 80);
	Cesium.HomelessFunction.injectionGoogleMap(Cesium);
	//pfAirViewer.extend(Cesium.viewerCesium3DTilesInspectorMixin);
	//pfAirViewer.extend(Cesium.viewerCesiumInspectorMixin);
	pfAirViewer.clock.shouldAnimate = true;
	//console.log(pfAirViewer.clock.shouldAnimate);
	pfAirViewer._dataSave._baseUri = "../../";
	//pfAirViewer._dataSave._baseUri = "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/";
	pfAirViewer._personLayerManager._dataBaseUri = new Cesium.Uri(pfAirViewer._dataSave._baseUri+"data/");

	var key = 'XFHlri0oWPBUfT9msrZN~f1oDt5rE6-k-4DB9eKy48A~Ai3GG386TlshTeMjSnDXKSZ9I3f8cIXXXyD9kDsg3YfWzfctHizlAhTPNk2G8LbN';
	Cesium.BingMapsApi.defaultKey = key;
	Cesium.Ion.defaultAccessToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2NWU0YzY3ZS1hOGYyLTQyM2YtYjcyNy00YTg1ZGUzYWY3NDEiLCJpZCI6MzkxLCJpYXQiOjE1MjUyMzIyOTF9.JhEYpfPMOGcY3ms958xRko1TEqha0S7YE5Ck_7k5pn8';

	import NavigationBar from '@/components/Navigation'
	import LeftBar from '@/components/LeftBar'
	import RightBar from '@/components/RightBar'
	import DashboardBar from '@/components/DashboardBar'
	export default {
		name: 'Main',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				userData: {
					userInfo: {
						isGuest: 'yes'
					}
				}
			}
		},
		components: {
			NavigationBar,
			LeftBar,
			RightBar,
			DashboardBar
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  	font-weight: normal;
}
ul {
  	list-style-type: none;
  	padding: 0;
}
li {
  	display: inline-block;
  	margin: 0 10px;
}
a {
  	color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue